var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskRecurrence = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.2 4.4h2.334V2.533h-4.667a.933.933 0 0 0-.933.934v4.666H12.8V5.701a5.136 5.136 0 0 1 1.449 7.17 5.13 5.13 0 0 1-3.315 2.175v1.89A7 7 0 0 0 14.2 4.4M7.2 14.298a5.136 5.136 0 0 1-1.448-7.17 5.13 5.13 0 0 1 3.315-2.175v-1.89A7 7 0 0 0 5.801 15.6H3.467v1.867h4.667a.933.933 0 0 0 .933-.933v-4.667H7.2z"
})));
export default SvgTaskRecurrence;